/** @jsx h */

import { h } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.scss';

import IconMinimize from '../../../IconMinimize';

const BtnMinimize = ({ onClick, className, white }) => {
    const btnClasses = classNames({
        [styles.btnMinimize]: true,
        [styles.white]: white,
        [className]: !!className,
    });
    return (
        <div className={btnClasses} onClick={onClick}>
            <IconMinimize />
        </div>
    );
};

BtnMinimize.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    white: PropTypes.bool,
};

BtnMinimize.defaultProps = {
    onClick: () => {},
    className: '',
    white: false,
};

export default BtnMinimize;
